import Vue from 'vue'
import cookies from 'vue-cookies'
import loginStore from '@/store/index.js'

export default {
   name: 'swisscom-footer',
   methods: {
      /**
       * Changes the current locale to the value of the selected option in the "Swisscom Select"
       * Languages are stored as a cookie.
       */
      changeLocale(locale) {
         Vue.config.lang = locale
         cookies.set('locale', locale)
         this.$i18n.locale = Vue.config.lang
         console.log('New locale = ' + Vue.config.lang)
      }
   },
   data() {
      return {
         // For setting the correct selected option for the "Swisscom Select"
         selectedLang: this.$i18n.locale,
         isLoggedIn: loginStore.getters.isLoggedIn === '4C4F4C20594147204D4F4D205255'
      }
   }
}
